import React, { Component } from "react";

import {
  Box, Text, Accordion, AccordionItem, AccordionButton, AccordionIcon, AccordionPanel, Flex} from '@chakra-ui/react';
import { JsonViewer } from "@textea/json-viewer";

import TelemetryLogGrid from "./TelemetryLogGrid";

export default class TelemetryLogPanel extends Component {
  constructor(props) {
    super(props);


    this.state = {
      selectedRow: null,
      isLoading: null
    };

    this.onRowSelected = this.onRowSelected.bind(this);
    this.setLoading = this.setLoading.bind(this);
  }

  async componentDidMount() {
    console.log("TelemetryLogPanel: componentDidMount");
  }





  onRowSelected(newSelectedRow) {
    console.log("OnRowSelectChange");
    console.log("set state for selectedRow");
    console.info(newSelectedRow);
    this.setState({
      selectedRow: newSelectedRow
    });
  }


  setLoading(loading) {
    this.setState({ isLoading: loading });
  }




  render() {

    return (

      <Box bgColor='#0a597e' borderRadius='5px' width='100%' padding='20px'>

        <div>

          <TelemetryLogGrid
            userSession={this.props.userSession}
            onErrorPageRequest={this.props.onErrorPageRequest}
            userSessionKey={this.props.userSessionKey} // used to trigger changes
            onToastRequest={this.props.onToastRequest}
            onMsgBoxRequest={this.props.onMsgBoxRequest}
            onHomePageRequest={this.props.onHomePageRequest}
            onLogoutRequest={this.props.onLogoutRequest}

            onRowSelected={this.onRowSelected}
            setLoading={this.setLoading}
          />
        </div>

        <Box height="100%" marginTop={"15px"} bgColor={"white"} border={"2px solid white"} borderRadius={'4px'}>
          <Accordion allowToggle >
            <AccordionItem>
              <AccordionButton>
                <Box as='span' flex='1' textAlign='left'> Batch Summary </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel bgColor={'#0a597e'}>
                {(this.state.selectedRow) ?
                  <Flex bgColor={"white"}>
                    <JsonViewer
                      displayDataTypes={false}
                      editable={false}
                      displaySize={false}
                      value={this.state.selectedRow}
                      defaultInspectDepth={1}
                    />



                  </Flex>
                  : <Text color={"white"} justifySelf={"center"}>Please Select A Record</Text>}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Box>
      </Box >

    );
  }
}
